import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { connect } from "../../core/context/ToneAudioNode";
import { Param } from "../../core/context/Param";
import { ToneAudioBuffer } from "../../core/context/ToneAudioBuffer";
import { defaultArg, optionsFromArguments } from "../../core/util/Defaults";
import { noOp } from "../../core/util/Interface";
import { isDefined } from "../../core/util/TypeCheck";
import { assert } from "../../core/util/Debug";
import { OneShotSource } from "../OneShotSource";
import { EQ, GTE, LT } from "../../core/util/Math";
/**
 * Wrapper around the native BufferSourceNode.
 * @category Source
 */

export var ToneBufferSource = /*#__PURE__*/function (_OneShotSource) {
  _inherits(ToneBufferSource, _OneShotSource);

  var _super = _createSuper(ToneBufferSource);

  function ToneBufferSource() {
    var _this;

    _classCallCheck(this, ToneBufferSource);

    _this = _super.call(this, optionsFromArguments(ToneBufferSource.getDefaults(), arguments, ["url", "onload"]));
    _this.name = "ToneBufferSource";
    /**
     * The oscillator
     */

    _this._source = _this.context.createBufferSource();
    _this._internalChannels = [_this._source];
    /**
     * indicators if the source has started/stopped
     */

    _this._sourceStarted = false;
    _this._sourceStopped = false;
    var options = optionsFromArguments(ToneBufferSource.getDefaults(), arguments, ["url", "onload"]);
    connect(_this._source, _this._gainNode);

    _this._source.onended = function () {
      return _this._stopSource();
    };
    /**
     * The playbackRate of the buffer
     */


    _this.playbackRate = new Param({
      context: _this.context,
      param: _this._source.playbackRate,
      units: "positive",
      value: options.playbackRate
    }); // set some values initially

    _this.loop = options.loop;
    _this.loopStart = options.loopStart;
    _this.loopEnd = options.loopEnd;
    _this._buffer = new ToneAudioBuffer(options.url, options.onload, options.onerror);

    _this._internalChannels.push(_this._source);

    return _this;
  }

  _createClass(ToneBufferSource, [{
    key: "fadeIn",
    get:
    /**
     * The fadeIn time of the amplitude envelope.
     */
    function get() {
      return this._fadeIn;
    },
    set: function set(t) {
      this._fadeIn = t;
    }
    /**
     * The fadeOut time of the amplitude envelope.
     */

  }, {
    key: "fadeOut",
    get: function get() {
      return this._fadeOut;
    },
    set: function set(t) {
      this._fadeOut = t;
    }
    /**
     * The curve applied to the fades, either "linear" or "exponential"
     */

  }, {
    key: "curve",
    get: function get() {
      return this._curve;
    },
    set: function set(t) {
      this._curve = t;
    }
    /**
     * Start the buffer
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given, it will default to the full length of the sample (minus any offset)
     * @param  gain  The gain to play the buffer back at.
     */

  }, {
    key: "start",
    value: function start(time, offset, duration) {
      var gain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      assert(this.buffer.loaded, "buffer is either not set or not loaded");
      var computedTime = this.toSeconds(time); // apply the gain envelope

      this._startGain(computedTime, gain); // if it's a loop the default offset is the loopstart point


      if (this.loop) {
        offset = defaultArg(offset, this.loopStart);
      } else {
        // otherwise the default offset is 0
        offset = defaultArg(offset, 0);
      } // make sure the offset is not less than 0


      var computedOffset = Math.max(this.toSeconds(offset), 0); // start the buffer source

      if (this.loop) {
        // modify the offset if it's greater than the loop time
        var loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration;
        var loopStart = this.toSeconds(this.loopStart);
        var loopDuration = loopEnd - loopStart; // move the offset back

        if (GTE(computedOffset, loopEnd)) {
          computedOffset = (computedOffset - loopStart) % loopDuration + loopStart;
        } // when the offset is very close to the duration, set it to 0


        if (EQ(computedOffset, this.buffer.duration)) {
          computedOffset = 0;
        }
      } // this.buffer.loaded would have return false if the AudioBuffer was undefined


      this._source.buffer = this.buffer.get();
      this._source.loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration;

      if (LT(computedOffset, this.buffer.duration)) {
        this._sourceStarted = true;

        this._source.start(computedTime, computedOffset);
      } // if a duration is given, schedule a stop


      if (isDefined(duration)) {
        var computedDur = this.toSeconds(duration); // make sure it's never negative

        computedDur = Math.max(computedDur, 0);
        this.stop(computedTime + computedDur);
      }

      return this;
    }
  }, {
    key: "_stopSource",
    value: function _stopSource(time) {
      if (!this._sourceStopped && this._sourceStarted) {
        this._sourceStopped = true;

        this._source.stop(this.toSeconds(time));

        this._onended();
      }
    }
    /**
     * If loop is true, the loop will start at this position.
     */

  }, {
    key: "loopStart",
    get: function get() {
      return this._source.loopStart;
    },
    set: function set(loopStart) {
      this._source.loopStart = this.toSeconds(loopStart);
    }
    /**
     * If loop is true, the loop will end at this position.
     */

  }, {
    key: "loopEnd",
    get: function get() {
      return this._source.loopEnd;
    },
    set: function set(loopEnd) {
      this._source.loopEnd = this.toSeconds(loopEnd);
    }
    /**
     * The audio buffer belonging to the player.
     */

  }, {
    key: "buffer",
    get: function get() {
      return this._buffer;
    },
    set: function set(buffer) {
      this._buffer.set(buffer);
    }
    /**
     * If the buffer should loop once it's over.
     */

  }, {
    key: "loop",
    get: function get() {
      return this._source.loop;
    },
    set: function set(loop) {
      this._source.loop = loop;

      if (this._sourceStarted) {
        this.cancelStop();
      }
    }
    /**
     * Clean up.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ToneBufferSource.prototype), "dispose", this).call(this);

      this._source.onended = null;

      this._source.disconnect();

      this._buffer.dispose();

      this.playbackRate.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(OneShotSource.getDefaults(), {
        url: new ToneAudioBuffer(),
        loop: false,
        loopEnd: 0,
        loopStart: 0,
        onload: noOp,
        onerror: noOp,
        playbackRate: 1
      });
    }
  }]);

  return ToneBufferSource;
}(OneShotSource);